module.exports = {
	"firebase": {
		"apiKey": "AIzaSyAY5PSHQgvClm9lCxnIbkBC1LrlqG4Dzc0",
		"authDomain": "mamamia-pwa-staging.firebaseapp.com",
		"databaseURL": "https://mamamia-pwa-staging.firebaseio.com",
		"projectId": "mamamia-pwa-staging",
		"storageBucket": "mamamia-pwa-staging.appspot.com",
		"messagingSenderId": "939919331930"
	},
	"previewUrl": "https://mamamia-pwa.firebaseapp.com/article-preview/",
	"froalaKey": "zEG4iA3C7C6B5F4A3g1pC-7ralkbF4fijD3hD-16wD1D1D1G1F1I4A9B1B6B5==",
	"apiAdmin": "https://us-central1-mamamia-admin.cloudfunctions.net",
	"apiFrontend": "https://us-central1-mamamia-pwa.cloudfunctions.net"
};


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 13
// module chunks = 1